module.exports = __webpack_public_path__ + "img/tournament-bg_768.47fc85fe.png";